import { render, staticRenderFns } from "./IntSiteOwner.vue?vue&type=template&id=638eab35"
import script from "./IntSiteOwner.vue?vue&type=script&lang=js"
export * from "./IntSiteOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports